import React from "react";
import { Minus, Plus } from "lucide-react";
type NumericCounterProps = {
  label: string;
  value: number;
  onChange: (value: number) => void;
  tone?: "green" | "red" | "gray";
};
const tones = {
  green: "text-[#176B3A] bg-[#eaf5ed]",
  red: "text-[#b42323] bg-[#fdeeee]",
  gray: "text-[#526258] bg-[#eef2ef]"
};
export function NumericCounter({
  label,
  value,
  onChange,
  tone = "green"
}: NumericCounterProps) {
  return <div className="flex items-center justify-between border-b border-[#e7eee8] py-3.5 last:border-0" data-id="element-143" data-mp="6jz9bb9glzjb"><span className="text-sm font-semibold text-[#38473d]" data-id="element-144" data-mp="bi0ohl3rlepi">{label}</span><div className="flex items-center gap-3" data-id="element-145" data-mp="bg65icc1zwo2"><button aria-label={`${label} কমান`} onClick={() => onChange(Math.max(0, value - 1))} className="flex h-9 w-9 items-center justify-center rounded-lg border border-[#cfe0d4] text-[#176B3A]" data-id="element-146" data-mp="g8z9uz3m12zm"><Minus size={17} data-id="element-147" data-mp="q7yjajw792no" /></button><span className={`flex h-9 min-w-[46px] items-center justify-center rounded-lg text-base font-bold ${tones[tone]}`} data-id="element-148" data-mp="q8ggbiqorkwn">{value}</span><button aria-label={`${label} বাড়ান`} onClick={() => onChange(value + 1)} className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#176B3A] text-white" data-id="element-149" data-mp="u9a48c44ozpj"><Plus size={17} data-id="element-150" data-mp="sjvddpxx9a8i" /></button></div></div>;
}